<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button [disabled]="!habilitarGuardar" *ngIf="!visibilitySpinner" type="submit" title="Guardar" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} CA Asociada Agente Control</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedEntidad = !isCollapsedEntidad"
                       [attr.aria-expanded]="!isCollapsedEntidad" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos Principales
                            <i *ngIf="isCollapsedEntidad" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedEntidad" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label class="col-form-label required-field" for="">Comunidad Autónoma</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listComunidad"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdCa"
                                           [readonly]="!listComunidad || listComunidad.length === 0"
                                           [loading]="!listComunidad || listComunidad.length === 0"
                                           notFoundText="Comunidad Autónoma no encontrada"
                                           [ngClass]="displayFieldCssNgSelect('IdCa')"
                                           placeholder="-- Seleccione una Comunidad Autónoma --"
                                           clearAllText="Eliminar selección">
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCa','required')">
                                    Comunidad Autónoma es obligatorio
                                </div>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCa','CA_duplicated')">
                                    La Comunidad Autónoma ya existe
                                </div>
                            </div>

                            <!--<div class="form-group col-md-1">
                                <label class="col-form-label" for="inpActivacionInicial">Alta</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="ActivacionInicial" onLabel="Sí" offLabel="NO"
                                                onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                            </div>-->

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFechaActivacionInicial">Fecha Activación</label>
                                <p-calendar formControlName="FechaActivacionInicial" inputStyleClass="form-control"
                                            [showIcon]="true" readonlyInput="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFechaBaja">Fecha Baja</label>
                                <div class="input-group">
                                    <p-calendar formControlName="FechaBaja" inputStyleClass="form-control"
                                                [showIcon]="true" readonlyInput="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                                </div>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inp">Activo</label>
                                <div class="input-group">
                                    <p-toggleButton class="form-control-togglebutton" formControlName="ActivacionInicial" onLabel="Sí" offLabel="NO"
                                                    onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                </div>
                            </div>

                        </div>

                        <!--GRUPOS Y FORMAS-->
                        <div class="row">

                            <div class="col-md-6">
                                <!-- -->

                                <div class="card card-accent-success animated fadeIn">

                                    <div class="card-header-buscador">
                                        <i class="fa fa-plus"></i> <strong id="stForma">Formas asociadas</strong>
                                        
                                        <!--<label class="col-form-label required-field" for="stFormas"></label>-->
                                    </div>
                                    <div class="card-body-detalle-list">

                                        <div class="row">
                                            <div class="col-md-12">

                                                <div class="form-group">

                                                    <div class="input-group">

                                                        <ng-select class="ngselect-listbox"
                                                                   [(items)]="listFormas"
                                                                   bindLabel="Descripcion"
                                                                   bindValue="Id"
                                                                   formControlName="IdForma"
                                                                   loadingText="Cargando..."
                                                                   [readonly]="!listFormas || listFormas.length === 0"
                                                                   [loading]="!listFormas || listFormas.length === 0"
                                                                   notFoundText="Forma no encontrada"
                                                                   placeholder="-- Seleccione una Forma --"
                                                                   clearAllText="Eliminar selección"
                                                                   [ngClass]="displayFieldCssNgSelect('IdForma')">
                                                            <ng-template ng-option-tmp let-item="item">
                                                                <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                            </ng-template>
                                                        </ng-select>

                                                        <button name="btnAddForma" class="btn btn-list btn-secondary btn-listbox"
                                                                type="button" title="Añade una forma" (click)="onAddForma()">
                                                            <i class="fa fa-plus"></i>
                                                        </button>

                                                        <!--<label class="col-form-label" style="margin-top:5px">ó Puntos de inspección por provincia</label>-->
                                                        <ng-select class="ngselect-listbox" style="padding-top:10px" 
                                                                   [(items)]="listGrupos"
                                                                   bindLabel="Descripcion"
                                                                   bindValue="Id"
                                                                   formControlName="IdGrupo"
                                                                   loadingText="Cargando..."
                                                                   [readonly]="!listGrupos || listGrupos.length === 0"
                                                                   [loading]="!listGrupos || listGrupos.length === 0"
                                                                   notFoundText="Grupo no encontrado"
                                                                   placeholder="-- Seleccione un Grupo --"
                                                                   clearAllText="Eliminar selección"
                                                                   [ngClass]="displayFieldCssNgSelect('IdGrupo')">
                                                        </ng-select>

                                                        <button name="btnAddFormaPorGrupo" class="btn btn-list btn-secondary btn-listbox" style="margin-top:10px"
                                                                type="button" title="Añade las Formas de un Grupo" (click)="onAddFormaPorGrupo()">
                                                            <i class="fa fa-plus"></i>
                                                        </button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="numFormas > 0" class="row">

                                            <div class="col-md-12">

                                                <label class="cabeceraTablaDetalles">Formas</label>

                                                <table class="table table-list table-sm">
                                                    <!--table-responsive-->
                                                    <tbody>
                                                        <tr *ngFor="let item of sortByForma('IdFormaDescripcion')">
                                                            <td scope="col">
                                                                <div class="btn-group">

                                                                    <button (click)="onDeleteForma(item)" type="button" [disabled]="!habilitarGuardar" title="Eliminar Forma"
                                                                            class="btn btn-sm btn-danger btn-listbox">
                                                                        <i class="fa fa-remove"></i>

                                                                    </button>
                                                                </div>
                                                            </td>

                                                            <td scope="col" class="td-list">{{item.IdFormaDescripcion}}</td>
                                                        </tr>

                                                    </tbody>
                                                </table>

                                                <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdForma','required')">
                                                    * Debe especificar una Forma
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
